import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductImageZoomProductImagesComponent } from '@spartacus/product/image-zoom/components';

@Component({
    selector: 'gen-product-images',
    templateUrl: './product-image-zoom-product-images.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenProductImageZoomProductImagesComponent extends ProductImageZoomProductImagesComponent {
 }
